import { render, staticRenderFns } from "./ShipReviewOverallCategoriesScorings.vue?vue&type=template&id=5ee4bd26&"
import script from "./ShipReviewOverallCategoriesScorings.vue?vue&type=script&lang=js&"
export * from "./ShipReviewOverallCategoriesScorings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports